/* eslint-disable */
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { GET_LISTDATA } from "../../actions";
import Select from "react-select";
import Chart from "react-apexcharts";
import { apiUrl } from "../Settings/Config";
import {
  showContaimerLoader,
  userID,
  showStatus,
  encodeValue,
  removeItem,
  showPriceValue,
} from "../Settings/Settings";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import Pagenation from "../Layout/Pagenation";
var module = "products/";
var moduleName = "Products";
class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userID: userID(),
      loading: true,
      totalRecords: 0,
      totalPage: 0,
      totalSale: 0,
      totalRevenue: 0,
      totalProduct: 0,
      totalCustomer: 0,
      currentPage: 1,
      listdata: [],
      name: "",
      status: "",

      options: {
        chart: {
          id: "apexchart-example",
        },
        xaxis: {
          categories: [],
        },
      },
      series: [
        {
          name: "Total Sale",
          data: [],
        },
      ],
    };
    this.handleChangeText = this.handleChangeText.bind(this);
  }

  componentDidMount() {
    this.loadList(1);
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.listdata !== this.state.listdata) {
      this.setState({
        listdata: nextProps.listdata,
        totalSale: nextProps.listdata.totalSale,
        totalRevenue: nextProps.listdata.totalRevenue,
        totalProduct: nextProps.listdata.totalProduct,
        totalCustomer: nextProps.listdata.totalCustomer,
        options: {
          chart: {
            id: "apexchart-example",
          },
          xaxis: {
            categories: nextProps.listdata.dateList,
          },
          yaxis: {
            title: {
              text: "Total Salse",
            },
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return "₹ " + val;
              },
            },
          },
        },
        series: [
          {
            name: "Total Sale",
            data: nextProps.listdata.saleDatas,
          },
        ],
        loading: false,
        totalRecords: nextProps.totalRecords,
        totalPage: nextProps.totalPages,
      });
    }
  }
  searchList() {
    this.setState({ loading: true }, function () {
      this.loadList(1);
    });
  }
  resetSearch() {
    this.setState(
      {
        loading: true,
        name: "",
        category: "",
        status: "",
      },
      function () {
        this.loadList(1);
      }
    );
  }
  loadList(offset) {
    var addParams = "";
    if (this.state.name !== "") {
      addParams += "&name=" + this.state.name;
    }
    if (
      this.state.status !== null &&
      Object.keys(this.state.status).length > 0
    ) {
      addParams += "&status=" + this.state.status.value;
    }
    var params = {
      params: "userID=" + this.state.userID + addParams,
      url: apiUrl + "dashboard/list",
    };
    this.props.getListData(params);
  }
  edit(editID) {
    this.props.history.push({
      pathname: "/products/edit",
      state: { editID: encodeValue(editID) },
    });
  }
  sateValChange = (field, value) => {
    if (field === "page") {
      this.setState(
        {
          loading: true,
          currentPage: value,
        },
        function () {
          this.loadList(value);
        }
      );
    }
  };
  handleChangeText(event) {
    var name = event.target.name;
    var value = event.target.value;
    this.setState({ [name]: value });
  }
  handleSelectChange(name, value) {
    this.setState({ [name]: value });
  }
  removeItem(deleteID) {
    var params = { delete_id: deleteID };
    var delurl = module + "delete";
    removeItem(params, delurl, this.sateValChange, this.state.currentPage);
  }

  render() {
    return (
      <div>
        <div className="page">
          <div className="page-main">
            <Header currentPage="dashboard" />

            <div className="main-content app-content">
              <div className="side-app">
                <div className="main-container container-fluid">
                  <div className="page-header">
                    <h1 className="page-title">{moduleName}</h1>
                  </div>
                  <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xl-12">
                      <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-12 col-xl-3">
                          <div className="card overflow-hidden">
                            <div className="card-body">
                              <div className="d-flex">
                                <div className="mt-2">
                                  <h6 className="">Total Sale</h6>
                                  <h2 className="mb-0 number-font">
                                    {showPriceValue(this.state.totalSale)}
                                  </h2>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 col-xl-3">
                          <div className="card overflow-hidden">
                            <div className="card-body">
                              <div className="d-flex">
                                <div className="mt-2">
                                  <h6 className="">Total Revenue</h6>
                                  <h2 className="mb-0 number-font">
                                    {showPriceValue(this.state.totalRevenue)}
                                  </h2>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 col-xl-3">
                          <div className="card overflow-hidden">
                            <div className="card-body">
                              <div className="d-flex">
                                <div className="mt-2">
                                  <h6 className="">Total Product</h6>
                                  <h2 className="mb-0 number-font">
                                    {this.state.totalProduct}
                                  </h2>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 col-xl-3">
                          <div className="card overflow-hidden">
                            <div className="card-body">
                              <div className="d-flex">
                                <div className="mt-2">
                                  <h6 className="">Total Customer</h6>
                                  <h2 className="mb-0 number-font">
                                    {this.state.totalCustomer}
                                  </h2>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-12 col-xl-12">
                      <div className="card">
                        <div className="card-header">
                          <h3 className="card-title">Last 1 Month Sale</h3>
                        </div>
                        <div className="card-body">
                          <Chart
                            options={this.state.options}
                            series={this.state.series}
                            type="line"
                            height={500}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  var listdata = Array();
  var listdataStatus = "";
  var totalPages = 0;
  var totalRecords = 0;
  if (Object.keys(state.listdata).length > 0) {
    listdataStatus = state.listdata[0].status;
    if (state.listdata[0].status === "ok") {
      listdata = state.listdata[0].result;
      totalPages = state.listdata[0].totalPages;
      totalRecords = state.listdata[0].totalRecords;
    }
  }
  return {
    listdata: listdata,
    totalPages: totalPages,
    totalRecords: totalRecords,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getListData: (datas) => {
      dispatch({ type: GET_LISTDATA, datas });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(List);
